import React from 'react';

const CheckIcon = function() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        className="check_icon_path"
        d="M1.57709 8.92388L5.19301 12.1356L12.2928 4.66699"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckIcon;
